const RESPONSE_DELAY = {
  RESPONSE_DELAY_FORM_TITLE: 'ایجاد عملیات جدید',
  RESPONSE_DELAY_DESC:
    'حتی زمانی که تمامی اپراتورهای شما مشغول هستند، همچنان به مشتریان خود توجه کنید!',
  RESPONSE_DELAY_LIST_TITLE: ' عملیات تاخیر در پاسخگویی',
  RESPONSE_DELAY_FORM_BTN: 'ایجاد عملیات جدید',
  RESPONSE_DELAY_LIST_BTN: 'لیست عملیات ها',
  ALL_DEPARTMENTS: 'اعمال بر روی تمام دپارتمان ها',
  ONE_DEPARTMENT: 'اعمال بر روی یک دپارتمان',
  ALL_DEPARTMENTS_LABEL: 'نوع اعمال عملیات',
  DEPARTMENT_SELECTION_LABEL: 'انتخاب دپارتمان',
  RESPONSE_DELAY_TIME_INPUT_LABEL: 'زمان انتظار',
  RESPONSE_DELAY_TIME_INPUT_LABEL_SECOND: 'ثانیه',
  RESPONSE_DELAY_TIME_INPUT_LABEL_MINUTE: 'دقیقه',
  RESPONSE_DELAY_TIME_INPUT_PLACEHOLDER_SECOND: 'ثانیه',
  RESPONSE_DELAY_TIME_INPUT_PLACEHOLDER_MINUTE: 'دقیقه',
  BEFORE_RESPONSE_DELAY_EDITOR_LABEL: 'متن پیام قبل از پاسخ',
  AFTER_RESPONSE_DELAY_EDITOR_LABEL: 'متن پیام بعد از پاسخ',
  RESPONSE_DELAY_EDITOR_PLACEHOLDER: 'پیام شما',
  FORM_GENERATOR_FIELD_LABEL: 'فیلد شماره ',
  FORM_GENERATOR_LABEL: 'برچسب فیلد را مشخص کنید',
  FORM_GENERATOR_PLACEHOLDER: 'نام فیلد را وارد کنید!',
  FORM_GENERATOR_TYPE: 'نوع فیلد را مشخص کنید',
  FORM_GENERATOR_BUTTON: 'افزودن فرم',
  RESPONSE_DELAY_DEFAULT_PREVIEW: 'به سایت ما خوش اومدین، در خدمتتون هستیم🖐',
  RESPONSE_DELAY_INCOMING: 'در انتظار پاسخ',
  RESPONSE_DELAY_IN_CONVERSATION: 'درحال مکالمه',
  RESPONSE_DELAY_TYPE_TITLE: 'ارسال در مکالمات',
  RESPONSE_DELAY_TABLE_TITLE_1: 'عنوان',
  RESPONSE_DELAY_TABLE_TITLE_2: 'وضعیت',
  RESPONSE_DELAY_TABLE_TITLE_3: 'فرم',
  RESPONSE_DELAY_TABLE_TITLE_4: 'همه دپارتمان‌ها',
  RESPONSE_DELAY_TABLE_TITLE_5: 'ویرایش و حذف',
  RESPONSE_DELAY_LIST_EMPTY: 'هیچ عملیاتی تعریف نشده است!',
  RESPONSE_DELAY_CONDITION_ACTIVE: 'فعال',
  RESPONSE_DELAY_CONDITION_INACTIVE: 'غیر فعال',
  RESPONSE_DELAY_YES: 'بله',
  RESPONSE_DELAY_NO: 'خیر',
  RESPONSE_DELAY_BTN_RELEASE: 'انتشار',
  RESPONSE_DELAY_BTN_CANCEL: 'انصراف',
  RESPONSE_DELAY_WIDGET_TITLE: 'پاسخگوی سوالات شما هستیم.',
  RESPONSE_DELAY_TYPE_HERE: 'اینجا تایپ کنید ...',
  RESPONSE_DELAY_POWERED_BY_RAYCHAT: 'قدرت گرفته از رایچت',
  RESPONSE_DELAY_FORM_INPUT_TYPE_STRING: 'متن',
  RESPONSE_DELAY_FORM_INPUT_TYPE_NUMBER: 'عدد',
  RESPONSE_DELAY_FORM_INPUT_TYPE_PHONE: 'شماره تلفن',
  RESPONSE_DELAY_FORM_INPUT_TYPE_EMAIL: 'ایمیل',
  RESPONSE_DELAY_FORM_INPUT_TYPE_NAME: 'نام',
  RESPONSE_DELAY_TITLE_INPUT_LABEL: 'عنوان فرم',
  RESPONSE_DELAY_TITLE_INPUT_PLACEHOLDER: 'عنوان ...',
  RESPONSE_DELAY_DELETE_MODAL: 'آیا از حذف عملیات انتخابی اطمینان دارید؟',
  RESPONSE_DELAY_DELETE_MODAL_SUBMIT_BTN: 'تایید',
  ERROR_MESSAGE: 'پر کردن فرم اضافه شده ضروری می‌باشد!',
  TIME_ERROR_MESSAGE: 'وارد کردن زمان انتظار ضروری می‌باشد!',
  BEFORE_RESPONSE_ERROR_MESSAGE: 'نوشتن متن پیام قبل از پاسخ ضروری می‌باشد!',
  AFTER_RESPONSE_ERROR_MESSAGE: 'نوشتن متن پیام بعد از پاسخ ضروری می‌باشد!',
  DEPARTMENT_ERROR_MESSAGE: 'انتخاب دپارتمان ضروری می‌باشد!',
  TITLE_ERROR_MESSAGE: 'نوشتن عنوان فرم ضروری می‌باشد!',
};

export default RESPONSE_DELAY;
